var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.06686 9.1956L8.06627 3.89782L13.1249 6.55585L8.06686 9.1956ZM19.174 2.9798C19.174 2.9798 18.9909 1.68055 18.4298 1.1084C17.7178 0.357133 16.9197 0.353591 16.554 0.309988C13.934 0.119077 10.0041 0.11908 10.0041 0.11908H9.99587C9.99587 0.11908 6.06588 0.119077 3.44589 0.309988C3.07963 0.353591 2.28217 0.357133 1.56954 1.1084C1.00844 1.68055 0.825896 2.9798 0.825896 2.9798C0.825896 2.9798 0.638672 4.50591 0.638672 6.03143V7.46208C0.638672 8.98819 0.825896 10.5137 0.825896 10.5137C0.825896 10.5137 1.00844 11.813 1.56954 12.3851C2.28217 13.1364 3.2177 13.1128 3.63428 13.1912C5.13209 13.3361 9.99996 13.3809 9.99996 13.3809C9.99996 13.3809 13.934 13.375 16.554 13.1841C16.9197 13.1399 17.7178 13.1364 18.4298 12.3851C18.9909 11.813 19.174 10.5137 19.174 10.5137C19.174 10.5137 19.3613 8.98819 19.3613 7.46208V6.03143C19.3613 4.50591 19.174 2.9798 19.174 2.9798Z",
    fill: "#00848D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.b0f41c9f3bc4ea00b0cb4915aa752dd0.svg";
export { ForwardRef as ReactComponent };